'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('doctor-setup', {
    url: '/doctor/:id/setup/:step/?clinic',
    templateUrl: '/views/doctor-setup.html',
    controller: 'DoctorSetupCtrl',
    data: {
      wizardView: true,
    },
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      doctor: function($stateParams, DoctorService) {
        return DoctorService.getDoctor($stateParams.id);
      },
      languages: function(LanguageService) {
        return LanguageService.listLanguages();
      },
      pageTitle: function($pageTitle, doctor) {
        $pageTitle.set('Setup - ' + doctor.name + ' - Opencare');
      },
    },
  });

  $stateProvider.state('doctor-create', {
    url: '/doctor/create/?clinic',
    templateUrl: '/views/doctor-setup.html',
    controller: 'DoctorSetupCtrl',
    data: {
      wizardView: true,
    },
    resolve: {
      auth: authorizationProvider.requireAuthorizedUser,
      doctor: function() {
        return {
          id: 'new',
          gender: null,
          languages: [{
            id: 1,
          }],
          insurancePlans: [],
        };
      },
      languages: function(LanguageService) {
        return LanguageService.listLanguages();
      },
      pageTitle: function($pageTitle) {
        $pageTitle.set('New Provider - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('DoctorSetupCtrl', function($scope, $location, $timeout, $state, $stateParams, $q, CurrentUser, OCWizardUtil, doctor, languages, GenderConstants, OpencareConstants, DoctorService, OCPhotoUtil, ClinicConfig, ProviderService, OCCDoctorUtil) {
  var INSURANCE_STEP_NUM = 2;
  var INSURANCE_STEP_ID = 'insurance';

  $scope.doctor = doctor;
  $scope.prefixes = ['', 'Dr.'];
  $scope.genders = GenderConstants.genderList;
  $scope.languages = languages;
  $scope.primaryPhotoForModel = OCPhotoUtil.primaryPhotoForModel;
  $scope.userClinics = CurrentUser.getClinics();

  if (!$scope.doctor.gender) {
    $scope.doctor.gender = '';
  }

  $scope.userSelected = {
    languages: _.pluck($scope.doctor.languages, 'id'),
    prefix: null,
    clinics: {},
  };

  var providerByClinic = _.indexBy($scope.doctor.providers, function(provider) {
    return provider.clinic.id;
  });

  angular.forEach(CurrentUser.getClinics(), function(clinic) {
    if (providerByClinic[clinic.id]) {
      $scope.userSelected.clinics[clinic.id] = true;
    }
  });

  var clinic = CurrentUser.getClinics();

  // Test the doctor name for each prefix, if its a match,
  // set the prefix in the dropdown selector and cut it from
  // the name.
  if ($stateParams.step == '1') {
    $scope.prefixes.forEach(function(prefix) {
      var re = new RegExp('^' + prefix + ' ');
      if (re.test($scope.doctor.name)) {
        $scope.userSelected.prefix = prefix;
        $scope.doctor.name = $scope.doctor.name.replace(re, '');
      }
    });
  }

  var initialStep = parseInt($stateParams.step || 1, 10);
  if (initialStep && initialStep === 1) {
    OpencareAnalytics.trackPageView({
      pageType: OpencareAnalytics.pageTypes.PROVIDER_MANAGER,
      pageName: clinic[0].name,
      name: 'add-new-provider',
      section: 'set-up-provider',
      practiceId: $stateParams.clinic,
    });
  }
  var targetStep = initialStep == INSURANCE_STEP_NUM
    && !OCCDoctorUtil.isInsuranceAvailable($scope.doctor)
    ? INSURANCE_STEP_NUM + 1
    : initialStep;
  OCWizardUtil.setStep($scope, targetStep);

  // angular-wizard library doesn't provide API to show/hide wizard steps depending on some conditions.
  // In these cases we need to get access to the wizard scope and manage steps manually.
  // In our case insurance step should be displayed only for US providers.
  var wizardScopeLoaded = false;

  // `$$childHead` is the wizard scope.
  $scope.$watch('$$childHead.steps', function(wizardStepScopes) {
    // Wait while scopes of the all step will be loaded.
    if (angular.isArray(wizardStepScopes) && !wizardScopeLoaded && wizardStepScopes.length == 3) {
      wizardScopeLoaded = true;

      // Hide insurance step.
      if (!OCCDoctorUtil.isInsuranceAvailable($scope.doctor)) {
        _.remove(wizardStepScopes, {
          wzTitle: INSURANCE_STEP_ID,
        });
      }
    }
  });

  $scope.$watch('userSelected.photo', () => {
    $scope.noPhoto = false;
  });

  $scope.nextStep = function() {
    var nextStep = parseInt($stateParams.step, 10) + 1;
    var trackStep = nextStep;

    if (nextStep == INSURANCE_STEP_NUM && !OCCDoctorUtil.isInsuranceAvailable($scope.doctor)) {
      trackStep = INSURANCE_STEP_NUM + 1;
    }

    var section;
    if (trackStep == 2 && OCCDoctorUtil.isInsuranceAvailable($scope.doctor)) {
      section = 'select-in-network-insurance';
    } else if (trackStep == 3 || (trackStep == 2 && !OCCDoctorUtil.isInsuranceAvailable($scope.doctor))) {
      section = 'select-clinics';
    }

    OpencareAnalytics.trackPageView({
      pageType: OpencareAnalytics.pageTypes.PROVIDER_MANAGER,
      pageName: clinic[0].name,
      name: 'add-new-provider',
      section: section,
      practiceId: $stateParams.clinic,
      content: {
        is_real_practice: String(!CurrentUser.isImpersonated()),
      },
    });

    $state.go($state.current.name, {
      step: nextStep,
    });
  };

  $scope.saveSetupInfo = function(form) {
    OpencareAnalytics.trackPageView({
      pageType: OpencareAnalytics.pageTypes.PROVIDER_MANAGER,
      pageName: clinic[0].name,
      name: 'add-new-provider',
      section: 'set-up-specialties',
      practiceId: $stateParams.clinic,
    });
    if (form.$invalid) {
      return $q.reject();
    }

    if (!$scope.userSelected.photo && !$scope.doctor.primaryPhoto) {
      $scope.noPhoto = true;
      return $q.reject();
    }

    var doctorName = $scope.userSelected.prefix ? $scope.userSelected.prefix + ' ' + $scope.doctor.name : $scope.doctor.name;

    if ($scope.doctor.id == 'new') {
      return DoctorService.createDoctor({
        name: doctorName,
        email: $scope.doctor.email,
        gender: $scope.doctor.gender || null,
        languages: $scope.userSelected.languages,
        metadata: {
          setupWizardComplete: true,
        },
      }).then(function(doctor) {
        return DoctorService.addSpecialty(doctor.id, OpencareConstants.specialtyId.DENTIST).then(function(specialties) {
          $scope.doctor.specialties = specialties;
          return doctor;
        });
      })
        .then(function(doctor) {
        // New doctor has been created, update nav.
          CurrentUser.update();

          OCPhotoUtil.uploadPhotoDataURI(ClinicConfig.HOSTNAME + '/doctor/' + doctor.id + '/photo/primary', $scope.userSelected.photo);

          // Replace /doctor/create/ in the path with step 1, so the back button
          // works as expected, then redirect to step 2.
          $location.path('/doctor/' + doctor.id + '/setup/1/').replace();
          $timeout(function() {
            $location.path('/doctor/' + doctor.id + '/setup/2/');
          });
          return doctor;
        });
    }

    return DoctorService.updateDoctor($scope.doctor, {
      name: doctorName,
      email: $scope.doctor.email,
      gender: $scope.doctor.gender,
      metadata: {
        setupWizardComplete: true,
      },
    }).then(function() {
      // Doctor name may have been updated, update nav.
      CurrentUser.update();

      return DoctorService.synchronizeLanguages($scope.doctor.id, _.pluck($scope.doctor.languages, 'id'), $scope.userSelected.languages);
    })
      .then(function() {
        $scope.nextStep();
      });
  };

  $scope.saveClinics = function(addAnotherProvider) {
    var promises = [];

    angular.forEach(CurrentUser.getClinics(), function(clinic) {
      var existingProvider = providerByClinic[clinic.id];

      if ($scope.userSelected.clinics[clinic.id]) {
        if (!existingProvider) {
          promises.push(ProviderService.createProvider(clinic.id, $scope.doctor.id));
        }
      } else {
        if (existingProvider) {
          promises.push(ProviderService.removeProvider(existingProvider.id));
        }
      }
    });

    return $q.all(promises)['finally'](function() {
      if (addAnotherProvider) {
        $state.go('doctor-create');
      } else {
        $scope.finish();
      }
    });

  };

  $scope.saveInsurance = function() {
    $scope.nextStep();
  };

  $scope.finish = function() {
    var clinicId = $stateParams.clinic;
    if (clinicId) {
      $state.go('clinic.schedule', {
        id: clinicId,
      }, {
        reload: true,
      });
    } else {
      $state.go('doctor', {
        id: $stateParams.id,
      }, {
        reload: true,
      });
    }
  };
});
